export const serializeColors = (colors) =>
  Object.fromEntries(
    Object.entries(colors).map(([key, val]) => [key, `hsl(${val.toColorString()})`])
  );

export const serializePaletteSchemes = (schemes) =>
  Object.fromEntries(
    Object.entries(schemes).map(([schemeId, scheme]) => {
      const serialized = { ...scheme };
      if (serialized.baseColor) {
        serialized.baseColor = serialized.baseColor.toCSSValue(false);
      }
      if (serialized.variableOverrides) {
        serialized.variableOverrides = Object.fromEntries(
          Object.entries(serialized.variableOverrides).map(([variableName, value]) => [
            variableName,
            typeof value === 'string' ? value : value.toCSSValue(),
          ])
        );
      }
      return [schemeId, serialized];
    })
  );
